import { render, staticRenderFns } from "./BoardListBusinessLayout.vue?vue&type=template&id=5640d79b&scoped=true&"
import script from "./BoardListBusinessLayout.vue?vue&type=script&lang=js&"
export * from "./BoardListBusinessLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5640d79b",
  null
  
)

export default component.exports